// extracted by mini-css-extract-plugin
export default {"root":"IconUserCircle_root__JULCO","disc":"IconUserCircle_disc__RUPV7","filled":"IconUserCircle_filled__SBpf5"};